/* ============================================================
   GOB — geo store recommendation (v4.2 logic, unchanged)
   Extracted 2026-08-25 from snippets/gob-geo-path-fix.liquid.

   8.6 KB that used to be inline on every page and could never be cached.
   The three Liquid-derived values (visitor country, country->currency map,
   locale root) stay inline as window.GOB_GEO; the logic lives here.

   Timing is unchanged: the block already deferred its own work to
   DOMContentLoaded when the document was still loading, and ran immediately
   otherwise — which is the state a deferred script sees.

   Still fails closed. If window.GOB_GEO is missing, currencyFor() finds
   nothing, and no popup is shown.
   ============================================================ */
(function(){
  'use strict';
  /* Liquid values arrive from the small inline block in the snippet — an asset
     file is never rendered through Liquid. Every one of these fails closed:
     no map means no currency, which means no popup. */
  var CFG       = window.GOB_GEO || {};
  var HERE      = CFG.here || '';
  var MAP       = CFG.map  || '';
  var ROOT      = CFG.root || '/';
  var COOKIE    = 'gob_geo_seen';
  var DISMISS_DAYS = 30;

  /* The countries the Europe market serves, i.e. everyone gameofbricks.eu is
     already the right store for. Taken straight from Markets > Europe. The
     France and Germany markets exist but are DISABLED, so FR and DE are served
     by Europe today and belong in this list; if either is ever enabled, move its
     code out of here and give it its own bucket. */
  var EU_MARKET = 'AX,AL,AD,AM,AT,BY,BE,BG,HR,CY,CZ,DK,EE,FO,FI,GE,GR,GL,GP,HU,'+
                  'IS,IE,IT,XK,LV,LT,LU,MT,YT,MC,ME,NL,NO,PL,PT,RO,SM,RS,SK,SI,'+
                  'ES,SJ,SE,CH,TR,UA,VA,JE,FR,DE';

  function cookieGet(n){
    var m = document.cookie.match('(^|;)\\s*'+n+'\\s*=\\s*([^;]+)');
    return m ? m.pop() : '';
  }
  function cookieSet(n,v,days){
    var d=new Date(); d.setTime(d.getTime()+days*864e5);
    document.cookie = n+'='+v+'; expires='+d.toUTCString()+'; path=/; SameSite=Lax';
  }
  /* returns the currency we price that country in, or '' if we do not sell there */
  function currencyFor(code){
    var m = (','+MAP).match(new RegExp(',' + code + ':([A-Z]{3}),'));
    return m ? m[1] : '';
  }

  /* Which of the three storefronts serves a country: the European store, the UK
     subfolder, or the .com store (United States + International + Australia). */
  function storeFor(code){
    if(code === 'GB') return 'GB';
    return (','+EU_MARKET+',').indexOf(','+code+',') > -1 ? 'EU' : 'COM';
  }
  /* Which storefront the shopper is looking at right now. Read off the URL, not
     off Liquid, because the URL is the one thing caching cannot get wrong. */
  function storeHere(){
    if(/^\/(en-)?gb(\/|$)/i.test(location.pathname)) return 'GB';
    return /(^|\.)gameofbricks\.eu$/i.test(location.hostname) ? 'EU' : 'COM';
  }

  /* .eu carries /nl/ and /en-gb/; .com is English-only. Strip a leading xx or
     xx-yy so the shopper lands on the same product on the other domain instead
     of a 404. */
  function carryPath(){
    var p = location.pathname.replace(/^\/[a-z]{2}(-[a-z]{2})?(?=\/|$)/i,'') || '/';
    return p + location.search + location.hash;
  }

  /* Klaviyo's teaser and this popup both want the screen. Hold Klaviyo back
     while we are on top, exactly as the previous version did. */
  function klSuppress(on){
    var id='gob-kl-suppress', s=document.getElementById(id);
    if(on){
      if(!s){ s=document.createElement('style'); s.id=id;
        s.textContent='[class*="kl-teaser"],[class*="klaviyo-form"],[class*="klaviyo-close-form"]{display:none !important;}';
        (document.head||document.documentElement).appendChild(s); }
    } else if(s){ s.remove(); }
  }

  function close(){
    var w=document.getElementById('gob-geo'); if(w) w.parentNode.removeChild(w);
    klSuppress(false);
    cookieSet(COOKIE,'1',DISMISS_DAYS);
    document.removeEventListener('keydown', onKey, true);
  }
  function onKey(e){ if(e.key==='Escape'||e.key==='Esc'){ e.preventDefault(); close(); } }

  function go(code){
    /* Shopify's own localization endpoint. It works out which market owns this
       country and, if that market has its own domain, redirects there. */
    var f=document.createElement('form');
    f.method='post'; f.action=ROOT+'localization'; f.acceptCharset='UTF-8'; f.style.display='none';
    [['form_type','localization'],['utf8','✓'],['_method','put'],
     ['country_code',code],['return_to',carryPath()]].forEach(function(kv){
      var i=document.createElement('input'); i.type='hidden'; i.name=kv[0]; i.value=kv[1]; f.appendChild(i);
    });
    document.body.appendChild(f);
    cookieSet(COOKIE,'1',DISMISS_DAYS);
    f.submit();
  }

  function render(code,name,cur){
    if(document.getElementById('gob-geo')) return;
    var wrap=document.createElement('div');
    wrap.id='gob-geo'; wrap.className='gob-geo';
    wrap.innerHTML =
      '<div class="gob-geo__card" role="dialog" aria-modal="true" aria-labelledby="gob-geo-h" tabindex="-1">'+
        '<button type="button" class="gob-geo__x" aria-label="Close">&times;</button>'+
        '<span class="gob-geo__kicker">Choose your store</span>'+
        '<span class="gob-geo__h" id="gob-geo-h">It looks like you’re in <span class="gob-geo__hl"></span></span>'+
        '<span class="gob-geo__sub">Shop our <span class="gob-geo__hl2"></span> store for local pricing'+
          '<span class="gob-geo__cur"></span> and faster delivery.</span>'+
        '<div class="gob-geo__btns">'+
          '<button type="button" class="gob-geo__yes"></button>'+
          '<button type="button" class="gob-geo__no">Stay on this store</button>'+
        '</div>'+
      '</div>';
    /* textContent, not innerHTML — the country name comes off the network */
    wrap.querySelector('.gob-geo__hl').textContent  = name;
    wrap.querySelector('.gob-geo__hl2').textContent = name;
    /* the currency is only named when we actually know it */
    wrap.querySelector('.gob-geo__cur').textContent = cur ? (' in '+cur) : '';
    wrap.querySelector('.gob-geo__yes').textContent = 'Go to '+name+' store';
    wrap.querySelector('.gob-geo__yes').addEventListener('click', function(){ go(code); });
    wrap.querySelector('.gob-geo__no').addEventListener('click', close);
    wrap.querySelector('.gob-geo__x').addEventListener('click', close);
    wrap.addEventListener('click', function(e){ if(e.target===wrap) close(); });
    document.body.appendChild(wrap);
    klSuppress(true);
    document.addEventListener('keydown', onKey, true);
    /* focus the dialog, not the primary button: a keyboard user still lands
       inside it, but a mouse user does not get an amber focus ring drawn on an
       amber button, which reads as a rendering fault rather than a state. */
    try{ wrap.querySelector('.gob-geo__card').focus(); }catch(e){}
  }

  function start(){
    try{
      if(cookieGet(COOKIE)) return;
      var ctl = ('AbortController' in window) ? new AbortController() : null;
      if(ctl) setTimeout(function(){ try{ ctl.abort(); }catch(e){} }, 4000);
      fetch(ROOT+'browsing_context_suggestions.json?country[enabled]=true',
            { headers:{'Accept':'application/json'}, signal: ctl?ctl.signal:undefined })
        .then(function(r){ return r.ok ? r.json() : null; })
        .then(function(j){
          if(!j || !j.detected_values || !j.detected_values.country) return;
          var code = j.detected_values.country.handle;
          var name = j.detected_values.country_name || j.detected_values.country.name;
          if(!code || !name) return;
          var cur = currencyFor(code);
          if(!cur) return;                            // we do not sell there
          if(code === HERE) return;                   // same country, nothing to offer
          if(storeFor(code) === storeHere()) return;  // already on the right storefront
          render(code, name, cur);
        })
        .catch(function(){});                // fail closed: no popup, no error
    }catch(e){}
  }

  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
